import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { NetworkDetector } from "@/services/networkDetector";
import { OfflineQueue } from "@/services/offlineQueue";
import { ReadNetwork, WriteNetwork } from "@/types/network";

export const NetworkService = new APIService<ReadNetwork, WriteNetwork>(
  API.Networks,
  OfflineQueue,
  NetworkDetector,
);
export const fetchNetworkList = NetworkService.getList;
export const fetchNetwork = NetworkService.get;
export const createNetwork = NetworkService.post;
export const updateNetwork = NetworkService.patch;
